

























import { defineComponent, useContext, computed } from '@nuxtjs/composition-api';
import { PropType } from '@vue/composition-api';
import { AmastyProductLabelsInterface, AmastyCategoryLabelsInterface } from '~/modules/GraphQL/types';

type LabelType = AmastyProductLabelsInterface | AmastyCategoryLabelsInterface;

export default defineComponent({
  name: 'AmLabels',
  props: {
    labels: {
      type: Array as PropType<(LabelType | null)[]>,
      default: () => [],
    },
    pagetype: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const context = useContext();
    const { magentoBaseUrl } = context.$vsf.$magento.config;

    const visibleLabels = computed(() => {
      return props.labels.filter((label) => {
        if (!label || label.is_visible !== true) return false;

        if (props.pagetype === 'am_product_labels') {
          return !!(label as AmastyProductLabelsInterface).product_id;
        }

        if (props.pagetype === 'am_category_labels') {
          return !!(label as AmastyCategoryLabelsInterface).product_id;
        }

        return true;
      }) as LabelType[];
    });
    return {
      magentoBaseUrl,
      visibleLabels
    };
  },
});
